import { FC } from 'react';

type Props = {
  viewBox?: { cx: number; cy: number };
  headline: string;
  description?: string;
};

export const DoughnutChartInsideLabel: FC<Props> = ({ headline, description, ...otherProps }) => {
  return (
    <>
      <text x={otherProps.viewBox?.cx} y={otherProps.viewBox?.cy} textAnchor="middle">
        <tspan alignmentBaseline="middle" fontSize="1.5rem" fontFamily="Roboto" fontWeight={300}>
          {headline}
        </tspan>
      </text>
      {description && (
        <text
          x={otherProps.viewBox?.cx}
          y={otherProps.viewBox && otherProps.viewBox.cy + 30}
          textAnchor="middle"
        >
          <tspan fontSize="1rem" fontFamily="Roboto" fontWeight={300}>
            {description}
          </tspan>
        </text>
      )}
    </>
  );
};
